import React, { useEffect, useMemo, useState } from "react";
import { Icon } from "../../../components/Component";
import { formatSize } from "./LivechatMedia";

const MAX_CAPTION = 4000;

// Full-body preview before sending, as on the WhatsApp chat: documents take no caption there
const LivechatAttachmentPreview = ({ attachment, onClose, onSend }) => {
  const [caption, setCaption] = useState("");
  const url = useMemo(() => (attachment ? URL.createObjectURL(attachment.file) : ""), [attachment]);
  const isDocument = attachment?.kind === "file";

  useEffect(() => () => url && URL.revokeObjectURL(url), [url]);
  useEffect(() => setCaption(""), [attachment]);

  if (!attachment) return null;

  const { file, kind } = attachment;
  const send = () => onSend(file, isDocument ? "" : caption.trim());

  return (
    <div className="send-image" style={{ top: 0, left: 0, width: "100%" }}>
      <div className="send-image-content d-flex flex-column">
        <button
          type="button"
          className="send-image-close text-soft btn btn-icon btn-trigger"
          aria-label="Batal kirim file"
          onClick={onClose}
        >
          <Icon name="cross-sm" />
        </button>
        <section className="flex-grow-1 overflow-hidden">
          <div className="d-flex justify-content-center p-4 h-100">
            {kind === "image" && (
              <img alt={file.name} className="rounded mw-100" style={{ height: "100%", objectFit: "contain" }} src={url} />
            )}
            {kind === "video" && <video preload="auto" controls style={{ height: "100%", maxWidth: "100%" }} src={url} />}
            {isDocument && (
              <div className="mt-5 text-center">
                <Icon name="file-fill" className="file-thumbnail" />
                <div className="mt-2 file-name">{file.name}</div>
                <div className="file-info">{`${formatSize(file.size)} - ${file.type.toUpperCase()}`}</div>
              </div>
            )}
          </div>
        </section>
        <div className="border-top d-flex align-item-center">
          <div className="nk-chat-editor w-100">
            <div className="nk-chat-editor-form">
              <div className="form-control-wrap">
                <textarea
                  className="form-control form-control-simple no-resize"
                  style={isDocument ? { backgroundColor: "white" } : { whiteSpace: "pre-line" }}
                  rows={Math.min(caption.split("\n").length, 5)}
                  aria-label="Keterangan file"
                  placeholder={isDocument ? "" : "Tulis keterangan..."}
                  maxLength={MAX_CAPTION}
                  disabled={isDocument}
                  value={caption}
                  onChange={(e) => setCaption(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
                      e.preventDefault();
                      send();
                    }
                  }}
                />
              </div>
            </div>
            <ul className="nk-chat-editor-tools g-2">
              <li>
                <button type="button" className="btn btn-round btn-primary btn-icon" aria-label="Kirim file" onClick={send}>
                  <Icon size="xl" name="send-alt" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivechatAttachmentPreview;
